/**
 * Copyright (c) 2023 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */
// This file is manullay maintained as the API does not generate the enum types for the WEB

export const MediaTypeEnum = {
  UNDEFINED: 0,
  IMAGE: 1,
  VIDEO: 2,
} as const

export type MediaTypeEnum = (typeof MediaTypeEnum)[keyof typeof MediaTypeEnum]

export const PrivacyEnum = {
  PUBLIC: 0,
  FRIENDS: 1,
  PRIVATE: 2,
} as const

export type PrivacyEnum = (typeof PrivacyEnum)[keyof typeof PrivacyEnum]

export const InterestCategoryEnum = {
  UNDEFINED: 0,
  GENERAL: 1,
  SEXUAL: 2,
} as const

export type InterestCategoryEnum = (typeof InterestCategoryEnum)[keyof typeof InterestCategoryEnum]

export const PronounEnum = {
  UNDEFINED: 0,
  HE_HIM: 1,
  SHE_HER: 2,
  THEY_THEM: 3,
} as const

export type PronounEnum = (typeof PronounEnum)[keyof typeof PronounEnum]

export const GenderEnum = {
  PRIVATE: 0,
  MALE: 1,
  FEMALE: 2,
  CIS_MALE: 3,
  CIS_FEMALE: 4,
  TRANS_MALE: 5,
  TRANS_FEMALE: 6,
  NONBINARY: 7,
  GENDER_FLUID: 8,
  GENDERQUEER: 9,
} as const

export type GenderEnum = (typeof GenderEnum)[keyof typeof GenderEnum]

export const SexualityEnum = {
  PRIVATE: 0,
  STRAIGHT: 1,
  BICURIOUS: 2,
  BISEXUAL: 3,
  GAY: 4,
  LESBIAN: 5,
  FLUID: 6,
  HETEROFLEXIBLE: 7,
  PAN: 8,
} as const

export type SexualityEnum = (typeof SexualityEnum)[keyof typeof SexualityEnum]

export const EthnicEnum = {
  PRIVATE: 0,
  CAUCASIAN: 1,
  BLACK: 2,
  EAST_INDIAN: 3,
  HISPANIC: 4,
  MIDDLE_EASTERN: 5,
  OTHER: 6,
} as const

export type EthnicEnum = (typeof EthnicEnum)[keyof typeof EthnicEnum]

export const BodyHairEnum = {
  PRIVATE: 0,
  NONE: 1,
  SHAVED: 2,
  TRIMMED: 3,
  AVERAGE: 4,
  HAIRY: 5,
  PARTIALLY_SHAVED: 6,
  LANDING_STRIP: 7,
} as const

export type BodyHairEnum = (typeof BodyHairEnum)[keyof typeof BodyHairEnum]

export const EducationEnum = {
  PRIVATE: 0,
  HIGHSCHOOL: 1,
  COLLEGE: 2,
  UNIVERSITY: 3,
} as const

export type EducationEnum = (typeof EducationEnum)[keyof typeof EducationEnum]

export const SmokingEnum = {
  PRIVATE: 0,
  NONE: 1,
  OCCASIONALLY: 2,
  CONSIDERATE_SMOKER: 3,
  SMOKER: 4,
  HEAVY_SMOKER: 5,
} as const

export type SmokingEnum = (typeof SmokingEnum)[keyof typeof SmokingEnum]

export const DrinkingEnum = {
  PRIVATE: 0,
  NONE: 1,
  OCCASIONALLY: 2,
  SOCIAL_DRINKER: 3,
  MOST_NIGHTS: 4,
  HEAVY_DRINKER: 5,
} as const

export type DrinkingEnum = (typeof DrinkingEnum)[keyof typeof DrinkingEnum]

export const WeedEnum = {
  PRIVATE: 0,
  NONE: 1,
  OCCASIONALLY: 2,
  SOCIAL_SMOKER: 3,
  MOST_NIGHTS: 4,
  HEAVY_SMOKER: 5,
} as const

export type WeedEnum = (typeof WeedEnum)[keyof typeof WeedEnum]

export const ExperienceEnum = {
  PRIVATE: 0,
  FIRST_TIMER: 1,
  BEGINNER: 2,
  EXPERIENCED: 3,
} as const

export type ExperienceEnum = (typeof ExperienceEnum)[keyof typeof ExperienceEnum]

export const BuildEnum = {
  PRIVATE: 0,
  SLIM: 1,
  ATHLETIC: 2,
  MEDIUM: 3,
  MUSCULAR: 4,
  LARGE: 5,
} as const

export type BuildEnum = (typeof BuildEnum)[keyof typeof BuildEnum]

export const RelationshipEnum = {
  UNDEFINED: 0,
  COUPLE: 1,
  ENGAGED: 2,
  LONG_TERM: 3,
  MARRIED: 4,
  OPEN: 5,
  POLY: 6,
  SINGLE: 7,
} as const

export type RelationshipEnum = (typeof RelationshipEnum)[keyof typeof RelationshipEnum]

export const ReportOutcomeEnum = {
  NO_ACTION: 'NO_ACTION',
  MANUAL_ACTION_TAKEN: 'MANUAL_ACTION_TAKEN',
  MORE_INFORMATION_REQUESTED: 'MORE_INFORMATION_REQUESTED',
  REFERRED_TO_COPYRIGHT: 'REFERRED_TO_COPYRIGHT',
  CONTENT_RESTRICTED: 'CONTENT_RESTRICTED',
  CONTENT_DELETED: 'CONTENT_DELETED',
  WARNING_ISSUED: 'WARNING_ISSUED',
  OWNERSHIP_TRANSFERRED: 'OWNERSHIP_TRANSFERRED',
  USER_TEMPORARY_BANNED: 'USER_TEMPORARY_BANNED',
  USER_PERMANENTLY_BANNED: 'USER_PERMANENTLY_BANNED',
  EXTERNAL_REPORT_FILED: 'EXTERNAL_REPORT_FILED',
} as const

export type ReportOutcomeEnum = (typeof ReportOutcomeEnum)[keyof typeof ReportOutcomeEnum]

export const ReportReasonEnum = {
  CHILD_SEXUAL_ABUSE_MATERIAL: 'CHILD_SEXUAL_ABUSE_MATERIAL',
  APPARENT_MINOR: 'APPARENT_MINOR',
  NON_CONSENSUAL_INTIMATE_IMAGERY: 'NON_CONSENSUAL_INTIMATE_IMAGERY',
  UNAUTHORIZED_SYNTHETIC_LIKENESS: 'UNAUTHORIZED_SYNTHETIC_LIKENESS',
  SEX_TRAFFICKING: 'SEX_TRAFFICKING',
  COMMERCIAL_SEX: 'COMMERCIAL_SEX',
  ANIMAL_ABUSE: 'ANIMAL_ABUSE',
  REAL_DEATH_OR_SNUFF: 'REAL_DEATH_OR_SNUFF',
  OTHER_ILLEGAL: 'OTHER_ILLEGAL',
  PERSONAL_ATTACK_OR_THREAT: 'PERSONAL_ATTACK_OR_THREAT',
  HARASSMENT_OR_BULLYING: 'HARASSMENT_OR_BULLYING',
  HATE_SPEECH: 'HATE_SPEECH',
  STALKING_OR_DOXXING: 'STALKING_OR_DOXXING',
  IMPERSONATION: 'IMPERSONATION',
  PERSONAL_INFORMATION: 'PERSONAL_INFORMATION',
  SPAM: 'SPAM',
  FAKE_PROFILE: 'FAKE_PROFILE',
  COPYRIGHT: 'COPYRIGHT',
  NOT_OWNER: 'NOT_OWNER',
  REQUEST_OWNER_TRANSFER: 'REQUEST_OWNER_TRANSFER',
  NO_LONGER_EXISTS: 'NO_LONGER_EXISTS',
  NOT_EVENT: 'NOT_EVENT',
  EVENT_MISREPRESENTATION: 'EVENT_MISREPRESENTATION',
  AUP_LISTING_VIOLATION: 'AUP_LISTING_VIOLATION',
  NSFW_INCORRECT: 'NSFW_INCORRECT',
  BAN_EVASION: 'BAN_EVASION',
  OTHER: 'OTHER',
} as const

export type ReportReasonEnum = (typeof ReportReasonEnum)[keyof typeof ReportReasonEnum]

// Group-related enums
export const GroupVisibilityEnum = {
  VISIBLE: 0,
  HIDDEN: 1,
} as const

export type GroupVisibilityEnum = (typeof GroupVisibilityEnum)[keyof typeof GroupVisibilityEnum]

export const GroupTypeEnum = {
  PUBLIC: 0,
  PRIVATE: 1,
} as const

export type GroupTypeEnum = (typeof GroupTypeEnum)[keyof typeof GroupTypeEnum]

export const GroupRoleEnum = {
  OWNER: 0,
  ADMIN: 1,
  MODERATOR: 2,
  MEMBER: 3,
} as const

export type GroupRoleEnum = (typeof GroupRoleEnum)[keyof typeof GroupRoleEnum]

export const GroupMemberStatusEnum = {
  ACTIVE: 0,
  MUTED: 1,
  BANNED: 2,
} as const

export type GroupMemberStatusEnum = (typeof GroupMemberStatusEnum)[keyof typeof GroupMemberStatusEnum]

export const GroupInvitationStatusEnum = {
  PENDING: 0,
  ACCEPTED: 1,
  DECLINED: 2,
} as const

export type GroupInvitationStatusEnum = (typeof GroupInvitationStatusEnum)[keyof typeof GroupInvitationStatusEnum]

export const GroupJoinRequestStatusEnum = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
} as const

export type GroupJoinRequestStatusEnum = (typeof GroupJoinRequestStatusEnum)[keyof typeof GroupJoinRequestStatusEnum]

export const ReactionTypeEnum = {
  LIKE: 0,
  LOVE: 1,
  HAHA: 2,
  WOW: 3,
  DROOL: 4,
  NAUGHTY: 5,
  WET: 6,
  HARD: 7,
} as const

export type ReactionTypeEnum = (typeof ReactionTypeEnum)[keyof typeof ReactionTypeEnum]
